module.exports = __webpack_public_path__ + "static/media/9DESA7.c240d571.jpg";